// 教师入住
import { post, get, deletefn, putfun } from './http.js'
export default {
  // 教师信息编辑
  async teacher_put (params) {
    return await putfun (`/user/teacher/${params.id}`,params)
  },
  // 教师信息提交
  async teacher_post (params) {
    return await post ('/user/teacher',params)
  },
  // 教师信息拉取
  async teacher_get (params) {
    return await get (`/user/teacher/${params}`)
  },
  // 下载承诺书
  async teacher_download (params) {
    return await post ('/user/teacher-download',params)
  },
}



// WEBPACK FOOTER //
// ./src/request/teacher.js